var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 386.667,
    height: 386.667,
    viewBox: "0 0 386.667 386.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M386.667,45.564,341.1,0,193.333,147.769,45.564,0,0,45.564,147.769,193.333,0,341.1l45.564,45.564L193.333,238.9,341.1,386.667,386.666,341.1,238.9,193.333Z",
    fill: "#a7a7a7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEmployee);
export default __webpack_public_path__ + "static/media/close-employee.5a628da0f93b4c95b34ee8471cd40854.svg";
export { ForwardRef as ReactComponent };